module.exports = __webpack_public_path__ + "static/gatku-tile-50195c4f4e9e8f4c82ce8146d958c666.jpg";